enum SignInProvider {
  Google = 'google.com',
  Apple = 'apple.com',
  Password = 'password',
}

export default SignInProvider;
